import {
    Icon, styled,
    ToggleButton, ToggleButtonGroup
} from '@mui/material'

import cls from 'classnames'

import Styles from './style'

export const ToggleBar = (props) => {
    const variant = props.variant ?? 'primary'

    const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => (Styles.toggleButtonGroup))

    const handleToggle = (event, newGrid) => {
        if (props.onChange) props.onChange(event, newGrid)
    }

    return (
        <StyledToggleButtonGroup
            fullWidth={true}
            size={props.size ?? 'small'}
            value={props.selected}
            onChange={handleToggle}
            className={cls(
                (variant === 'primary') ? 'primary' : 'secondary',
                props.orientation ?? 'horizontal',
                (props.disabled ?? false) ? 'disabled': ''
            )}
            disabled={props.disabled ?? false}
            orientation={props.orientation ?? 'horizontal'}
            exclusive
            style={{width: props.width ?? 'unset', ...props.style}}
        >
            {props.buttons && props.buttons.length > 0 && props.buttons.map(item => {
                return (
                    <ToggleButton
                        key={item.id}
                        value={item.id}
                        sx={Styles.button}
                        disabled={item.disabled ?? false}
                        className={cls(
                            (props.selected === item.id) ? 'selected' : '',
                            (variant === 'primary') ? 'primary' : 'secondary',
                            (item.disabled) ? 'disabled' : ''
                        )}
                    >
                        {item.icon && (<Icon>{item.icon}</Icon>)} {item.label}
                    </ToggleButton>
                )
            })}
        </StyledToggleButtonGroup>
    )
}

export default ToggleBar